/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import { ReleaseSongStatus } from 'services/api/entities/distribution/release';
import { SongType } from 'services/api/entities';
import { ReleaseData, ReleaseFieldType } from '../types';

export const hasError = (release: ReleaseData) => {
  const songTitle = release[ReleaseFieldType.SongTitle];
  if (songTitle.error) {
    return true;
  }
  const { metadata } = release.songs[0];
  return Object.values(metadata).some((field) => field.error);
};

export const getSongStatus = (release: ReleaseData) => {
  if (hasError(release)) {
    return ReleaseSongStatus.ERROR;
  }

  const songTitle = release[ReleaseFieldType.SongTitle];
  if (!songTitle.data) {
    return ReleaseSongStatus.WARNING;
  }

  const { songType, metadata } = release.songs[0];
  if (songType === SongType.USER_UPLOADED) {
    const { composer, has_vocals, vocals_content, language } = metadata;

    if (
      !composer.data ||
      (has_vocals.data && (!vocals_content.data || !language.data))
    ) {
      return ReleaseSongStatus.WARNING;
    }
  }

  return ReleaseSongStatus.VALID;
};
